import { render, staticRenderFns } from "./AvatarDropdown.vue?vue&type=template&id=396e0399&scoped=true&"
import script from "./AvatarDropdown.vue?vue&type=script&lang=js&"
export * from "./AvatarDropdown.vue?vue&type=script&lang=js&"
import style0 from "./AvatarDropdown.vue?vue&type=style&index=0&id=396e0399&lang=scss&scoped=true&"
import style1 from "./AvatarDropdown.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396e0399",
  null
  
)

export default component.exports